<section class="calendar-join-shell" [attr.aria-label]="'Join ' + brand.name + ' meeting'">
  <div class="calendar-join-card">
    <ng-container *ngIf="status() === 'joining'; else errorState">
      <mat-spinner diameter="44"></mat-spinner>
    </ng-container>
    <ng-template #errorState>
      <div class="calendar-join-error-icon" aria-hidden="true">!</div>
    </ng-template>
    <p class="calendar-join-message">{{ message() }}</p>
    <a *ngIf="status() === 'error'" class="calendar-join-login-link" [routerLink]="['/auth/login']">
      Go to login
    </a>
  </div>
</section>
